import { multiStatusRequest } from '../../publish-steps/containers/publish-steps-actions';
import {
  deleteLaneData,
  deletePlanningDataPostSocket,
  deletePreview,
  fetchForwardBlockData,
  fetchForwardBlocksData,
  fetchPlanningDataPostSocketUpdate,
  forwardPlanningPlanned,
} from './gantt-actions';

const ganttSockets = [
  {
    eventType: 'ForwardPlanningCreated',
    actions: [data => fetchForwardBlocksData({
      ids: data.forwardPlannings.map(f => f.forwardPlanningId),
    })],
  },
  {
    eventType: 'ForwardPlanningUpdated',
    actions: [data => fetchForwardBlockData({
      boardId: 'forward',
      id: data.forwardPlanningId,
    })],
  },
  {
    eventType: 'ForwardPlanningIsPlanned',
    actions: [data =>
      forwardPlanningPlanned({
        laneId: data.technicianId,
      })],
  },
  {
    eventType: 'ForwardPlanningAborted',
    actions: [data =>
      deleteLaneData({
        id: data.forwardPlanningId,
        laneId: data.technicianId,
      })],
  },
  {
    eventType: 'ForwardPlanningRequestDiscarded',
    actions: [data =>
      deletePreview({
        end: data.end,
        start: data.start,
        laneIds: data.technicianIds,
      })],
  },
  {
    eventType: 'PlanningUpdated',
    actions: [
      data => fetchPlanningDataPostSocketUpdate(data),
    ],
  },
  {
    eventType: 'PlanningDeleted',
    actions: [
      data => deletePlanningDataPostSocket(data),
    ],
  },
  {
    eventType: 'PlanningPublishingTransactionUpdated',
    actions: [
      data =>
        multiStatusRequest({ ids: [data.newEntityId || data.entityId] }),
    ],
  },
];

export default ganttSockets;
